<template>
	<svg width="28" height="28" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
		<!-- <rect width="56" height="56" rx="28" fill="#E9F0FD"/> -->
		<g clip-path="url(#clip0_1492_124710)">
			<path d="M37.8752 26.4001L28.1616 16.6865L30.424 14.4241L44 28.0001L30.424 41.5761L28.1616 39.3137L37.8752 29.6001H12V26.4001H37.8752Z" />
		</g>
		<defs>
			<clipPath id="clip0_1492_124710">
				<rect width="32" height="32" fill="white" transform="translate(12 12)"/>
			</clipPath>
		</defs>
	</svg>
</template>

<script>
export default {
	name: 'IconArrowRight',
};
</script>

